export const tabItems = /** @type {const} */ ({
  home: 'home',
  trends: 'trends',
  appliances: 'appliances',
  faults: 'faults',
  control: 'control',
  heating: 'heating',
  solar: 'solar',
  chemical: 'chemical',
  spa: 'spa',
  pump: 'pump',
  applianceSetup: 'applianceSetup',
  system: 'system',
  filter: 'filter',
});

export const dashTabItems = {
  control: 0,
  heating: 1,
  solar: 2,
  chemical: 3,
  pump: 4,
  spa: 5,
  system: 6,
  filter: 7,
  systemInfo: 8,
};

export const faultView = {
  current: 0,
  history: 1,
};

export const locations = ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'NZ'];

export const locationsOptions = [
  { value: 0, label: 'ACT' },
  { value: 1, label: 'NSW' },
  { value: 2, label: 'NT' },
  { value: 3, label: 'QLD' },
  { value: 4, label: 'SA' },
  { value: 5, label: 'TAS' },
  { value: 6, label: 'VIC' },
  { value: 7, label: 'WA' },
  { value: 8, label: 'NZ' },
];

export const sortKeys = {
  uid: 0,
  type: 1,
  name: 2,
  status: 3,
};

export const sortOrder = {
  ascending: 0,
  descending: 1,
};
